function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CroatiaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_3467",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_3467)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_3467",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_3467)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V9H24V3H0Z",
        fill: "#E31D1C"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15V21H24V15H0Z",
        fill: "#3D58DB"
      }), /*#__PURE__*/_jsx("rect", {
        x: "7.55743",
        y: "7.79799",
        width: "8.55",
        height: "3",
        fill: "#E31D1C"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.84762 9.57924H15.7227C15.7385 10.1283 15.743 11.2252 15.7429 12.2711C15.7428 12.8968 15.7412 13.4991 15.7395 13.9451C15.7387 14.168 15.7379 14.3518 15.7373 14.4799L15.7366 14.6282L15.7364 14.6602L15.7341 14.6743C15.7305 14.6961 15.7245 14.7294 15.7155 14.7726C15.6974 14.8591 15.6672 14.9848 15.6194 15.1367C15.5235 15.4412 15.3585 15.8458 15.0825 16.2487C14.5383 17.0432 13.5511 17.8521 11.7374 17.8521C9.92523 17.8521 8.98229 17.0433 8.47963 16.253C8.224 15.8511 8.07861 15.4471 7.99738 15.1425C7.95689 14.9907 7.9327 14.8649 7.91876 14.7784C7.91179 14.7352 7.9074 14.7019 7.90482 14.6802L7.9025 14.6592L7.90248 14.6579L7.90201 14.6193L7.90023 14.4721L7.89386 13.9406C7.88859 13.4975 7.88156 12.8985 7.87453 12.2751C7.8629 11.2431 7.85129 10.1468 7.84762 9.57924Z",
        fill: "#F7FCFF",
        stroke: "#E31D1C",
        strokeWidth: "0.5625"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_3467",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "9",
        width: "10",
        height: "10",
        children: /*#__PURE__*/_jsx("path", {
          d: "M7.84762 9.57924H15.7227C15.7385 10.1283 15.743 11.2252 15.7429 12.2711C15.7428 12.8968 15.7412 13.4991 15.7395 13.9451C15.7387 14.168 15.7379 14.3518 15.7373 14.4799L15.7366 14.6282L15.7364 14.6602L15.7341 14.6743C15.7305 14.6961 15.7245 14.7294 15.7155 14.7726C15.6974 14.8591 15.6672 14.9848 15.6194 15.1367C15.5235 15.4412 15.3585 15.8458 15.0825 16.2487C14.5383 17.0432 13.5511 17.8521 11.7374 17.8521C9.92523 17.8521 8.98229 17.0433 8.47963 16.253C8.224 15.8511 8.07861 15.4471 7.99738 15.1425C7.95689 14.9907 7.9327 14.8649 7.91876 14.7784C7.91179 14.7352 7.9074 14.7019 7.90482 14.6802L7.9025 14.6592L7.90248 14.6579L7.90201 14.6193L7.90023 14.4721L7.89386 13.9406C7.88859 13.4975 7.88156 12.8985 7.87453 12.2751C7.8629 11.2431 7.85129 10.1468 7.84762 9.57924Z",
          fill: "white",
          stroke: "white",
          strokeWidth: "0.5625"
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: "url(#mask2_621_3467)",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.87384 9.77992H9.45587V11.3863H11.0379V9.77992H12.6199V11.3863H14.202V9.77992H15.784V11.3863H14.202V12.9928H12.6199V11.3863H11.0379V12.9928H9.45587V11.3863H7.87384V9.77992ZM11.0379 14.5992H9.45587V12.9928H7.87384V14.5992H9.45587V16.2056H11.0379V14.5992H12.6199V16.2056H14.202V14.5992H15.784V12.9928H14.202V14.5992H12.6199V12.9928H11.0379V14.5992ZM15.784 16.2056H14.202V17.8121H15.784V16.2056ZM11.0379 16.2056H12.6199V17.8121H11.0379V16.2056ZM9.45587 16.2056H7.87384V17.8121H9.45587V16.2056Z",
          fill: "#F50100"
        })
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.8398 9.12194C7.8398 9.12194 8.32913 8.86057 8.74649 8.72587C9.16385 8.59117 9.49373 8.51758 9.49373 8.51758L8.87277 6.22851L7.62903 5.76382L6.92462 6.9249L7.8398 9.12194Z",
        fill: "#56C6F5",
        stroke: "white",
        strokeWidth: "0.15"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9056 8.30683C10.9056 8.30683 11.3229 8.26959 11.7614 8.27811C12.1999 8.28663 12.5708 8.28974 12.5708 8.28974L12.785 6.03263L11.8457 5.18409L10.8017 6.05258L10.9056 8.30683Z",
        fill: "#56C6F5",
        stroke: "white",
        strokeWidth: "0.15"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.38736 8.48834L9.40897 8.56175L9.48193 8.53866L9.48194 8.53866L9.48199 8.53864L9.48223 8.53857L9.48321 8.53826L9.48721 8.53701L9.50283 8.53215L9.56108 8.51442C9.61062 8.49955 9.67969 8.47931 9.75775 8.45782C9.91494 8.41454 10.1048 8.36729 10.2454 8.34776C10.3884 8.32788 10.5649 8.31355 10.7066 8.30417C10.7772 8.2995 10.8388 8.29608 10.8827 8.29383L10.9342 8.29133L10.9479 8.29072L10.9514 8.29057L10.9523 8.29053L10.9525 8.29052L10.9526 8.29052L10.9526 8.29052L11.031 8.2873L11.0242 8.20914L10.835 6.01583L10.832 5.98123L10.8037 5.96112L9.78167 5.23527L9.72906 5.19791L9.68427 5.24435L8.75541 6.20728L8.72512 6.23868L8.73744 6.28053L9.38736 8.48834Z",
        fill: "#2E42A5",
        stroke: "white",
        strokeWidth: "0.15"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask3_621_3467",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "8",
        y: "5",
        width: "4",
        height: "4",
        children: /*#__PURE__*/_jsx("path", {
          d: "M9.38736 8.48834L9.40897 8.56175L9.48193 8.53866L9.48194 8.53866L9.48199 8.53864L9.48223 8.53857L9.48321 8.53826L9.48721 8.53701L9.50283 8.53215L9.56108 8.51442C9.61062 8.49955 9.67969 8.47931 9.75775 8.45782C9.91494 8.41454 10.1048 8.36729 10.2454 8.34776C10.3884 8.32788 10.5649 8.31355 10.7066 8.30417C10.7772 8.2995 10.8388 8.29608 10.8827 8.29383L10.9342 8.29133L10.9479 8.29072L10.9514 8.29057L10.9523 8.29053L10.9525 8.29052L10.9526 8.29052L10.9526 8.29052L11.031 8.2873L11.0242 8.20914L10.835 6.01583L10.832 5.98123L10.8037 5.96112L9.78167 5.23527L9.72906 5.19791L9.68427 5.24435L8.75541 6.20728L8.72512 6.23868L8.73744 6.28053L9.38736 8.48834Z",
          fill: "white",
          stroke: "white",
          strokeWidth: "0.15"
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: "url(#mask3_621_3467)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.1689 8.4867L14.1485 8.56227L14.0738 8.53866L14.0738 8.53866L14.0738 8.53864L14.0735 8.53857L14.0726 8.53826L14.0686 8.53701L14.0529 8.53215L13.9947 8.51442C13.9452 8.49955 13.8761 8.47931 13.798 8.45782C13.6408 8.41454 13.451 8.36729 13.3104 8.34776C13.1674 8.32788 12.9909 8.31355 12.8492 8.30417C12.7786 8.2995 12.717 8.29608 12.6731 8.29383L12.6216 8.29133L12.6079 8.29072L12.6043 8.29057L12.6035 8.29053L12.6033 8.29052L12.6032 8.29052L12.6032 8.29052L12.5248 8.2873L12.5316 8.20914L12.7208 6.01583L12.7237 5.98123L12.7521 5.96112L13.7741 5.23527L13.8282 5.19686L13.8729 5.24585L14.7487 6.20515L14.7764 6.23553L14.7657 6.27526L14.1689 8.4867Z",
        fill: "#2E42A5",
        stroke: "white",
        strokeWidth: "0.15"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask4_621_3467",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "12",
        y: "5",
        width: "3",
        height: "4",
        children: /*#__PURE__*/_jsx("path", {
          d: "M14.1689 8.4867L14.1485 8.56227L14.0738 8.53866L14.0738 8.53866L14.0738 8.53864L14.0735 8.53857L14.0726 8.53826L14.0686 8.53701L14.0529 8.53215L13.9947 8.51442C13.9452 8.49955 13.8761 8.47931 13.798 8.45782C13.6408 8.41454 13.451 8.36729 13.3104 8.34776C13.1674 8.32788 12.9909 8.31355 12.8492 8.30417C12.7786 8.2995 12.717 8.29608 12.6731 8.29383L12.6216 8.29133L12.6079 8.29072L12.6043 8.29057L12.6035 8.29053L12.6033 8.29052L12.6032 8.29052L12.6032 8.29052L12.5248 8.2873L12.5316 8.20914L12.7208 6.01583L12.7237 5.98123L12.7521 5.96112L13.7741 5.23527L13.8282 5.19686L13.8729 5.24585L14.7487 6.20515L14.7764 6.23553L14.7657 6.27526L14.1689 8.4867Z",
          fill: "white",
          stroke: "white",
          strokeWidth: "0.15"
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: "url(#mask4_621_3467)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.9111 9.09465L15.8788 9.16927L15.807 9.13094L15.807 9.13094L15.807 9.13094L15.8069 9.13091L15.8067 9.13079L15.8057 9.13026L15.8017 9.12813L15.7858 9.11978C15.7718 9.11249 15.7513 9.10188 15.7254 9.08871C15.6735 9.06237 15.6 9.02583 15.5135 8.98512C15.3401 8.90344 15.1168 8.80599 14.9126 8.74009C14.7056 8.67327 14.5202 8.62158 14.3865 8.58661C14.3197 8.56914 14.266 8.55585 14.2289 8.54695L14.1865 8.53692L14.1756 8.53442L14.1729 8.53381L14.1723 8.53366L14.1721 8.53363L14.1721 8.53362L14.1721 8.53362L14.1721 8.53362L14.0945 8.51633L14.1163 8.43991L14.7508 6.208L14.7611 6.17152L14.7967 6.15825L16.0404 5.69357L16.0986 5.67184L16.1308 5.72492L16.8352 6.886L16.8553 6.91917L16.8399 6.95476L15.9111 9.09465Z",
        fill: "#56C6F5",
        stroke: "white",
        strokeWidth: "0.15"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask5_621_3467",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "14",
        y: "5",
        width: "3",
        height: "5",
        children: /*#__PURE__*/_jsx("path", {
          d: "M15.9111 9.09465L15.8788 9.16927L15.807 9.13094L15.807 9.13094L15.807 9.13094L15.8069 9.13091L15.8067 9.13079L15.8057 9.13026L15.8017 9.12813L15.7858 9.11978C15.7718 9.11249 15.7513 9.10188 15.7254 9.08871C15.6735 9.06237 15.6 9.02583 15.5135 8.98512C15.3401 8.90344 15.1168 8.80599 14.9126 8.74009C14.7056 8.67327 14.5202 8.62158 14.3865 8.58661C14.3197 8.56914 14.266 8.55585 14.2289 8.54695L14.1865 8.53692L14.1756 8.53442L14.1729 8.53381L14.1723 8.53366L14.1721 8.53363L14.1721 8.53362L14.1721 8.53362L14.1721 8.53362L14.0945 8.51633L14.1163 8.43991L14.7508 6.208L14.7611 6.17152L14.7967 6.15825L16.0404 5.69357L16.0986 5.67184L16.1308 5.72492L16.8352 6.886L16.8553 6.91917L16.8399 6.95476L15.9111 9.09465Z",
          fill: "white",
          stroke: "white",
          strokeWidth: "0.15"
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: "url(#mask5_621_3467)"
      })]
    })]
  })]
}));
//# sourceMappingURL=Croatia.js.map